import axios, {AxiosInstance, AxiosResponse} from "axios"
import jwt_decode  from 'jwt-decode';
import {LOGOUT} from "../action/types";

class axiosHandler {
    axiosInstance: AxiosInstance;
    store; // redux store
    workingRequestsCount: number;
    refreshingPromise: Promise<AxiosResponse<any>> | null;

    static getInstance(store) {
        let retInst = null;
        if (this.axiosInstance) {
            this.axiosInstance.store = store;
            retInst = this.axiosInstance;
        } else {
            retInst = this.createAxiosInstance(store);
        }
        return retInst;
    }

    static sendToken = () => async dispatch => {
        let accessToken = localStorage.getItem('access');
        let refreshToken = localStorage.getItem('refresh');
        let idToken = localStorage.getItem('id');
        // comunico al WebGIS i dati del token
        const iFrame = document.querySelector("iframe");
        const data = {
            access_token: accessToken,
            refresh_token: refreshToken,
            id_token: idToken
        };
        iFrame.contentWindow.postMessage(data, "*");
    }

    static promiseToSetAuthTokenToConfig = (config) => {
        const _this = this;
        let access = localStorage.getItem('access');
        let refresh = localStorage.getItem('refresh');

        // faccio passare alcune chiamate
        if (config.url.includes('token') || (config.url.includes(process.env.REACT_APP_API_URL) && !config.url.includes('logout'))) {
            return Promise.resolve(config);
        }

        if (_this.isValidToken(access)) {
            // aggiungo il token
            const newConfig = _this.addTokenToPromise(config, access);
            return Promise.resolve(newConfig);
        } else if (_this.isValidToken(refresh)) {
            return _this.refreshToken()
                .then((tokenData) => {
                    if (tokenData.data.error) {
                        this.refreshingPromise = null;
                        if (this.store) {
                            this.store.dispatch({
                                type: LOGOUT
                            });
                        }
                        return Promise.reject(config);
                    } else {
                        const {
                            data: {
                                access_token,
                                refresh_token,
                                id_token
                            }
                        } = tokenData;
                        const actualaccess = localStorage.getItem('access');
                        let actualRefresh = localStorage.getItem('refresh');
                        const actualId = localStorage.getItem('id');
                        if (actualaccess !== access_token || actualRefresh !== refresh_token || actualId !== id_token) {
                            _this.setToken(access_token);
                            _this.setToken(refresh_token);
                            _this.setToken(id_token);
                            console.log(`Sending new token...`);
                            this.sendToken();
                        }
                        // aggiungo il nuovo token
                        const newConfig = _this.addTokenToPromise(config, access_token);
                        return Promise.resolve(newConfig);
                    }
                }).finally(() => {
                    this.refreshingPromise = null;
                });
        } else {
            console.log(`Token has expired!`);
            if (this.store) {
                this.store.dispatch({
                    type: LOGOUT
                });
            }
            return Promise.reject(config);
        }
    }
    
    static isValidToken = (access) => {
        let valid = false;
        if (access) {
            const decodedToken: any = jwt_decode(access);
            const expirationDate = new Date(decodedToken.exp * 1000);
            valid = access && expirationDate >= new Date();
        }
        return valid;
    }

    static setToken = (token) => {
        let value = "";
        const decodedToken: any = jwt_decode(token);
        switch (decodedToken.typ.toLowerCase()) {
            case "id":
                value = 'id';
                break;
            case "refresh":
                value = 'refresh';
                break
            case 'bearer':
            default:
                value = 'access';
        }
        localStorage.setItem(value, token);
    }

    static getWorkingRequestsCount() {
        return this.workingRequestsCount;
    }

    static addAWorkingRequest() {
        this.workingRequestsCount = this.getWorkingRequestsCount() + 1;
    }

    static removeAWorkingRequest() {
        this.workingRequestsCount = Math.max(0, this.getWorkingRequestsCount() - 1);
    }

    static refreshToken = async () => {
        if (!this.refreshingPromise) {
            // avvio il refresh del token
            console.log("CMS is requesting new Access Token");
            const refresh = localStorage.getItem('refresh');
            const postParams = new URLSearchParams();
            postParams.append('grant_type', "refresh_token");
            postParams.append('refresh_token', `${refresh}`);
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
            this.refreshingPromise = axios.post(
                `${process.env.REACT_APP_API_URL}/store/token`,
                postParams, config);
        }
        return this.refreshingPromise;
    }

    static createAxiosInstance = (store) => {
        const _this = this;

        this.store = store;
        this.workingRequestsCount = 0;

        let axiosInstance = axios.create({
            // need to be changed, 60000 is correct
            // timeout: 60000*5,
            // headers: {
            //   common: {
            //     "Access-Control-Allow-Origin": "*"
            //   }
            // }
        })

        axiosInstance.interceptors.request.use((config) => {
            return new Promise((resolve) => {
                let interval = setInterval(() => {
                    if (_this.getWorkingRequestsCount() <= 6) {
                        _this.addAWorkingRequest();
                        clearInterval(interval)
                        resolve(_this.promiseToSetAuthTokenToConfig(config))
                    }
                }, 200)
            });
        }, (error) => {
            return Promise.reject(error);
        });

        axiosInstance.interceptors.response.use((response) => {
            _this.removeAWorkingRequest()
            return Promise.resolve(response)
        }, (error) => {
            _this.removeAWorkingRequest()
            return Promise.reject(error)
        });

        return axiosInstance;
    }

    static addTokenToPromise = (config, token) => {
        if (config.url.includes(process.env.REACT_APP_MAPIT_API_NP_DOWNLOAD) || config.url.includes(process.env.REACT_APP_MAPIT_API_ROUTINE_DOWNLOAD)) {
            config.url = config.url.split('?auth=')[0] + `?auth=${token}`
        } else {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    }
}

export default axiosHandler;
